// import our vuex state management
import store from '@/store';

export default {

  methods: {

    // method for navigating back and forward a page at a time
    navigateThroughPages(direction) {

      // we do not want our route detection to fire
      store.commit('setNavigatingPages', true);

      // get current page
      const currentPage = store.getters.getCurrentPage;

      // calculate new path
      const path = direction > 0 ? `page/${currentPage + 1}/index.html` : `page/${currentPage - 1}/index.html`;
      //   if ( (path > 1) && (path < 3 ) ) `page/welcome/index.html`;

      // set reading content to false
      store.commit('setReadingContent', false);

      // dispatch the action
      store.dispatch('navigatePages', { path, direction });

    },

    closeReadingAndNavigateToPage(path) {

      // check if we are reading content and want to close it first
      const readingContent = store.getters.getReadingContent;
      if (readingContent) {

        store.commit('setReadingContent', false);
        store.commit('setCloseContent', true);

        setTimeout(() => {
          store.dispatch('navigatePages', { path, direction: -1 });
        }, 500);

        return;

      }

      store.dispatch('navigatePages', { path, direction: -1 });

    }

  }
};
